import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/plate-appearance#
// A plate appearance refers to a batter's turn at the plate. Each completed turn batting is one plate appearance. Plate appearances can often be confused with at-bats. But unlike with at-bats -- which only occur on certain results -- a plate appearance takes into account every single time a batter comes up and a result between batter and pitcher is obtained.
const classifiesAsPlateAppearance = function(paResult) {
    switch (paResult) {
        // Base hits
        case PlateAppearanceResult.Double.key:
        case PlateAppearanceResult.GroundRuleDouble.key:
        case PlateAppearanceResult.HomeRun.key:
        case PlateAppearanceResult.InsideTheParkHomeRun.key:
        case PlateAppearanceResult.Single.key:
        case PlateAppearanceResult.Triple.key:
        // walks
        case PlateAppearanceResult.Walk.key:
        case PlateAppearanceResult.IntentionalWalk.key:
        // dropped 3rd
        case PlateAppearanceResult.WildPitch.key:
        case PlateAppearanceResult.PassedBall.key:
        // batter out, sacrifice
        case PlateAppearanceResult.SacrificeBunt.key:
        case PlateAppearanceResult.SacrificeFly.key:
        case PlateAppearanceResult.SacrificePlay.key:
        // batter out - strikeout
        case PlateAppearanceResult.SwingingStrikeout.key:
        case PlateAppearanceResult.CalledStrikeout.key:
        case PlateAppearanceResult.FoulTipOut.key:
        case PlateAppearanceResult.FoulOut.key:
        // batter out - other
        case PlateAppearanceResult.BatterInterference.key:
        case PlateAppearanceResult.BatterOut.key:
        case PlateAppearanceResult.FieldOut.key:
        case PlateAppearanceResult.InfieldFly.key:
        // batter safe - other
        case PlateAppearanceResult.FieldersChoice.key:
        case PlateAppearanceResult.ReachedOnError.key:
        case PlateAppearanceResult.SacrificeOnError.key:
        case PlateAppearanceResult.SacrificeOnFieldersChoice.key:
        case PlateAppearanceResult.HitByPitch.key:
        case PlateAppearanceResult.CatcherInterference.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsPlateAppearance;